/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { CallbackType, FRAuth, StepType, type FRLoginFailure, type FRLoginSuccess, type FRStep } from '@forgerock/javascript-sdk';
import React, { useEffect, useState } from 'react';
import { trees } from '../../config/forgerockConfig';
import { MessageType } from '../../interfaces/baseInterface';
import CallbasedViewGenerator from '../../components/common/CallbasedViewGenerator/CallbasedViewGenerator';
import { cloneDeep } from 'lodash';
import { checkAndValidatePortalParam, getTree, gotoAndResumeUseEffect, handleFailureStep, handlePortalName, redirectHandle } from '../../utils/FRCallBackUtil';
import Loader from '../../components/common/Loader/Loader';

const PasswordReset: React.FC = () => {

  const [step, setStep] = useState<FRStep | FRLoginFailure | FRLoginSuccess | null>(null);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState<MessageType>(MessageType.info);

   const tree = getTree('PasswordReset');
   handlePortalName();
   
  gotoAndResumeUseEffect({ setStep, setGoto: () => { }, setRedirectURI: () => { }, setMaintenancePage: () => { }, tree });
  checkAndValidatePortalParam();

  useEffect(() => {
    if (step && step.type === StepType.LoginFailure) {
      sessionStorage.removeItem('authIndexValue');
      sessionStorage.removeItem('step');
      sessionStorage.removeItem('realm');
      const failStep = step
      handleFailureStep({
        failStep,
        setStep,
        setIsAlertOpen,
        setMessageType,
        setMessage,
        tree,
        restartOnFailure: true
      });
    }
  }, [step]);

  const resendOtp = async () => {
    let stepCopy = cloneDeep(step as FRStep);
    stepCopy.getCallbackOfType(CallbackType.StringAttributeInputCallback).setInputValue("1");
    setMessage("")
    setIsAlertOpen(false)
    let nextStep = await FRAuth.next(stepCopy as FRStep, { tree });
    setStep(nextStep);
  }


  const getPasswordResetView = () => {
    let uiElement = <Loader />;
    if (step && step.type === StepType.Step) {
      sessionStorage.removeItem('authIndexValue');
      sessionStorage.removeItem('step');
      sessionStorage.removeItem('realm');

      const onClickFunctionMap = new Map<string, Function>();
      switch (step.getStage()) {
        case "CheckCodeEmail":
          onClickFunctionMap.set("resend", resendOtp);
          break;
        case "RedirectMFA":
          sessionStorage.setItem('step', JSON.stringify(step))
          sessionStorage.setItem('redirectOrgin', window.location.origin + window.location.pathname)
          sessionStorage.setItem('redirectQuery', window.location.search)
          redirectHandle(step, tree);
          return uiElement;

      }
      uiElement = <CallbasedViewGenerator step={step as FRStep} setStep={setStep}
        tree={tree} messageType={messageType} setMessageType={setMessageType}
        message={message} setMessage={setMessage} isAlertOpen={isAlertOpen} setIsAlertOpen={setIsAlertOpen} onClickFunctionMap={onClickFunctionMap}></CallbasedViewGenerator>

    }
    return uiElement;
  }

  return (
    <>{getPasswordResetView()}

    </>
  );
};

export default PasswordReset;
